/* App component */
export const SET_ROUTE = 'SET_ROUTE';
export const SET_LOCATION = 'SET_LOCATION';
export const REQUEST_CURRENT_POSITION_PENDING = 'REQUEST_CURRENT_POSITION_PENDING';
export const REQUEST_CURRENT_POSITION_SUCCESS = 'REQUEST_CURRENT_POSITION_SUCCESS';
export const REQUEST_CURRENT_POSITION_FAILED = 'REQUEST_CURRENT_POSITION_FAILED';

/* SearchField component */
export const UPDATE_INPUT = 'UPDATE_INPUT;'
export const REQUEST_SEARCH_OPTIONS_PENDING = 'REQUEST_SEARCH_OPTIONS_PENDING';
export const REQUEST_SEARCH_OPTIONS_SUCCESS = 'REQUEST_SEARCH_OPTIONS_SUCCESS';
export const REQUEST_SEARCH_OPTIONS_FAILED = 'REQUEST_SEARCH_OPTIONS_FAILED';

/* CurrentWeather component */
export const REQUEST_CURRENT_WEATHER_PENDING = 'REQUEST_CURRENT_WEATHER_PENDING';
export const REQUEST_CURRENT_WEATHER_SUCCESS = 'REQUEST_CURRENT_WEATHER_SUCCESS';
export const REQUEST_CURRENT_WEATHER_FAILED = 'REQUEST_CURRENT_WEATHER_FAILED';

/* FiveDayForecast component */
export const REQUEST_FIVE_DAY_FORECAST_PENDING = 'REQUEST_FIVE_DAY_FORECAST_PENDING';
export const REQUEST_FIVE_DAY_FORECAST_SUCCESS = 'REQUEST_FIVE_DAY_FORECAST_SUCCESS';
export const REQUEST_FIVE_DAY_FORECAST_FAILED = 'REQUEST_FIVE_DAY_FORECAST_FAILED';

/* Favorites component */
export const CLEAR_DATA = 'CLEAR_DATA';
export const REQUEST_FAVORITES_CURRENT_CONDITIONS_PENDING = 'REQUEST_FAVORITES_CURRENT_CONDITIONS_PENDING';
export const REQUEST_FAVORITES_CURRENT_CONDITIONS_SUCCESS = 'REQUEST_FAVORITES_CURRENT_CONDITIONS_SUCCESS';
export const REQUEST_FAVORITES_CURRENT_CONDITIONS_FAILED = 'REQUEST_FAVORITES_CURRENT_CONDITIONS_FAILED';